import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "my-6 overflow-hidden bg-white rounded-md shadow grid grid-cols-2 gap-3" }

import DonutChart from "@/components/charts/DonutChart.vue";
import LineChart from "@/components/charts/LineChart.vue";
import BarChart from "../components/charts/BarChart.vue";
import AreaChart from "../components/charts/AreaChart.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "text-gray-600" }, "Charts", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(LineChart),
          _createVNode(DonutChart),
          _createVNode(BarChart),
          _createVNode(AreaChart)
        ])
      ])
    ])
  ]))
}
}

})